module.exports = __webpack_public_path__ + "media/login.44c4743f.mp4";